import './Footer.css';
import Background from '../Background/Background';

const Footer = () => {
    return (
        <Background>
            <div className="footer">
                <h3>Ⓒ Skule Commuter Students Directorship 2025.<br/>All rights reserved.</h3>
            </div>
        </Background>
    );
}

export default Footer;